import styled, { css } from "styled-components";
import { rgbaToHex } from "../../../sharable/PickerAndSelector";
import {
  ROUND_LOGO_WITH_BORDER,
  SQUARE_LOGO_WITH_BORDER,
} from "../EncarteConstants";
import { ROBOTO_FONT } from "../../ToolBarMenuViews/StylesMenuView/useFormatFontFamily";

export const CanvasWrapper = styled.div`
width: min-content;
height; min-content;
  @media print {
    display: flex;
    width: 100%;
    height: 100%;
    justify-content: center;
    align-items: center;
    margin-top: 0;
  }
`;

export const GridProducts = styled.div`
  display: grid;
  position: relative;
  height: 100%;
  gap: 0.4rem;

  ${({ grid, canvasScale }) => {
    const columns = grid?.columns ? grid.columns : 0;
    const rows = grid?.rows ? grid.rows : 0;
    return css`
      padding: ${1.6 * canvasScale}rem;
      grid-template-columns: repeat(${columns}, 1fr);
      grid-template-rows: repeat(${rows}, 1fr);
      gap: ${10 * canvasScale}px;
      margin: 0 ${0 * canvasScale}px;
    `;
  }}
`;

export const Canvas = styled.div`
  margin-top: 3rem;
  @media print {
    margin-top: 0;
  }
  display: grid;
  grid-template-columns: 1fr;
  background-size: cover;
  position: relative;
  overflow: hidden;
  ${({ canvasScale, model, styles, dimensions, footerRowHeight }) => {
    const dim = dimensions;
    const header = dim.header;
    const footer = dim.footer;
    const fontFamily = styles?.fontFamily;
    const txtColor = styles?.txtColor;
    const gridHeight = dim.height - header - footerRowHeight;

    return css`
      display: grid;
      grid-template-rows: ${header * canvasScale}px ${gridHeight *
        canvasScale}px ${footerRowHeight * canvasScale}px;
      background-image: url("${model.urlTmp}");
      flex-direction: column;
      box-shadow: 0 20px 20px 5px rgba(1, 1, 1, 0.1);
      width: ${dim.width * canvasScale}px;
      height: ${dim.height * canvasScale}px;
      font-family: ${fontFamily ? fontFamily : ROBOTO_FONT} !important;
      color: ${txtColor} !important;
    `;
  }};
`;

export const Footer = styled.div`
  height: 100%;
  text-transform: uppercase;
  line-height: 1.3;
  background-position: bottom;
  background-size: cover;
  text-transform: capitalize;
  ${({ canvasScale, model, styles }) => {
    return css`
      padding: 0 ${54 * canvasScale}px ${12 * canvasScale}px
        ${54 * canvasScale}px;
      padding-top: 0;
      background-image: url(${model.urlTmp});
      font-size: ${24 * canvasScale}px;
      .logo,
      h1 {
        font-size: ${42 * canvasScale}px;
        line-height: 0.6;
      }

      p {
        margin-top: ${2.4 * canvasScale}rem;
        font-size: ${24 * canvasScale}px;
      }
    `;
  }}
  .logo-social-wrapper {
    align-items: center;
  }

  column-gap: 2rem;
`;

export const Contacts = styled.div``;

export const Header = styled.div`
  position: relative;
  overflow: hidden;
`;

export const BrandLogo = styled.div`
  ${({ logo, canvasScale, size, position }) => {
    return css`
      position: absolute;
      bottom: ${position?.bottom}%;
      right: ${position?.right}%;
      width: ${size * canvasScale}px;
      height: ${size * canvasScale}px;
      background-position: center;
      background-image: url(${logo});
      background-size: contain;
      background-repeat: no-repeat;
    `;
  }}

  ${({ logoStyle, canvasScale, headerStyles }) => {
    const borderRadius =
      logoStyle === ROUND_LOGO_WITH_BORDER
        ? "50%"
        : logoStyle === SQUARE_LOGO_WITH_BORDER
          ? "15%"
          : "0%";

    return css`
      ${borderRadius && `border-radius: ${borderRadius};`}

      border: ${10 * canvasScale}px solid ${headerStyles?.bgColor
        ? rgbaToHex(headerStyles.bgColor, 1)
        : "#fff"};
      background-color: #fff;
    `;
  }}
`;

export const calcProductStylesOcurrence = (products) => {
  // Helper to count occurrences of a value in an array
  const countOccurrences = (arr) => {
    const map = {};
    arr.forEach((val) => {
      if (!val) return;
      map[val] = (map[val] || 0) + 1;
    });
    return map;
  };

  // Collect all style values
  const txtColors = products.map((p) => p.styles?.txtColor);
  const bgColors = products.map((p) => p.styles?.bgColor);
  const priceTxtColors = products.map((p) => p.styles?.priceTxtColor);
  const priceBgColors = products.map((p) => p.styles?.priceBgColor);

  // Count occurrences
  const txtColorCounts = countOccurrences(txtColors);
  const bgColorCounts = countOccurrences(bgColors);
  const priceTxtColorCounts = countOccurrences(priceTxtColors);
  const priceBgColorCounts = countOccurrences(priceBgColors);

  // Helper to get the most used color
  const getMostUsed = (counts) => {
    let max = 0;
    let color = undefined;
    for (const key in counts) {
      if (counts[key] > max) {
        max = counts[key];
        color = key;
      }
    }
    return color;
  };

  // Font size average
  let fontSizeSum = 0;
  products.forEach((p) => {
    fontSizeSum += Number(p.styles?.fontSize);
  });

  const stylesObj = {
    txtColor: getMostUsed(txtColorCounts),
    bgColor: getMostUsed(bgColorCounts),
    priceTxtColor: getMostUsed(priceTxtColorCounts),
    priceBgColor: getMostUsed(priceBgColorCounts),
    fontSize: fontSizeSum / products.length,
  };
  return stylesObj;
};
